import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dataCompare, dataCompare_currency, compare_currency_other } from "@/api/dataAll/dataCompare";
import pageMinx from "./mixins/pageMinx";
export default {
  mixins: [tabulation, pageMinx],
  data: function data() {
    return {
      // finallyFn: ['integralPoint'],
      reqFn: 'integralPoint',
      originaltableList: [],
      originaltableListP: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }],
      originaltableListVND: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费金额(元,越南盾)',
        key: 'new_device_recharge_amountexchange'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '充值总额(元,越南盾)',
        key: 'recharge_amountexchange'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }, {
        name: '新增账号付费金额(元,越南盾)',
        key: 'recharge_amountexchange'
      }],
      originaltableListUSD: [{
        name: '激活设备数',
        key: 'activate_device'
      }, {
        name: '新增设备付费金额(元)',
        key: 'new_device_recharge_amount'
      }, {
        name: '新增设备付费金额(元,美元)',
        key: 'new_device_recharge_amountexchange'
      }, {
        name: '新增设备付费数',
        key: 'new_device_recharge_num'
      }, {
        name: '充值总额(元)',
        key: 'recharge_amount'
      }, {
        name: '充值总额(元,美元)',
        key: 'recharge_amountexchange'
      }, {
        name: '注册账号',
        key: 'register_num'
      }, {
        name: '登录账号',
        key: 'login_num'
      }, {
        name: '付费账号',
        key: 'recharge_num'
      }, {
        name: '在线账号',
        key: 'online_num'
      }, {
        name: 'ARPPU',
        key: 'arppu'
      }, {
        name: '新增付费账号数',
        key: 'register_recharge_pnum'
      }, {
        name: '新增账号付费金额(元)',
        key: 'register_recharge_amount'
      }, {
        name: '新增账号付费金额(元,美元)',
        key: 'register_recharge_amountexchange'
      }],
      IntegralrawData: {},
      screen: [],
      tableList: [],
      name: 'comparison'
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    resettingData: function resettingData() {
      this.tableData = [];
      this.tableList = [];
      this.IntegralrawData = {};
    },
    // 整点对比
    integralPoint: function integralPoint() {
      var _this = this;

      var isverification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.rawData.game_mark) {
        return;
      } // if(this.currencyClose && !this.searchData.currency_info){
      //   if(isverification){
      //     this.$message.error('请选择货币类型')
      //   }        
      //   return
      // }


      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(replace) {
          var res, dbres, currentHour, startTime, endTime, reqFn, handleQueryData, PrimitiveList, dateList, cacheHourData, cacheHourObj, list, day, numt, hourDate, mathNum, queryData, defaultData, recombination, searchHoour, querylist, i, Hds, qd, k, hd;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.reqLoading = true; // 初始化响应对象

                  res = {
                    data: {}
                  }; // 从数据库获取数据

                  _context.next = 4;
                  return _this.$DBControls.get(_this.name + _this.dataConvert());

                case 4:
                  dbres = _context.sent;

                  if (!(dbres && dbres.code == 500)) {
                    _context.next = 8;
                    break;
                  }

                  _this.integralPoint(true);

                  return _context.abrupt("return");

                case 8:
                  // 获取当前小时
                  currentHour = _this.$times.theDay('HH');
                  startTime = _this.$times.timestampToTime((new Date(_this.$times.zeroTimeZone()).getTime() - 3600 * 1000 * 24 * 2) / 1000, 'YY-MM-DD');
                  endTime = _this.$times.timestampToTime(new Date(_this.$times.zeroTimeZone()).getTime() / 1000, 'YY-MM-DD'); // 定义请求函数

                  reqFn = dataCompare;

                  if (_this.currencyClose && !_this.searchData.pay_channel) {
                    reqFn = dataCompare_currency;
                  } else if (_this.searchData.pay_channel) {
                    reqFn = compare_currency_other;
                  }

                  _context.next = 15;
                  return _this.getexchangeRate();

                case 15:
                  if (_this.queryCurrency == 'VND') {
                    _this.originaltableList = _this.originaltableListUSD;
                  } else if (_this.queryCurrency == 'USD') {
                    _this.originaltableList = _this.originaltableListP;
                  } else {
                    _this.originaltableList = _this.originaltableListP;
                  }

                  _this.screen = _this.originaltableList.map(function (item) {
                    return item.key;
                  }); // 数据处理函数

                  handleQueryData = function handleQueryData(queryData) {
                    if (queryData.status === 200) {
                      var dataToUpdate = {};

                      var PrimitiveList = _this.$times.getDayAll(startTime, endTime);

                      PrimitiveList.forEach(function (i) {
                        dataToUpdate[i] = queryData.data[i];
                      });
                      var dataNew = JSON.parse(JSON.stringify(dataToUpdate));
                      var currentHourList = {};

                      for (var k in dataNew[endTime]) {
                        if (parseInt(k) < currentHour) {
                          currentHourList[k] = dataNew[endTime][k];
                        }
                      }

                      var endData = _objectSpread({}, dataNew[endTime]);

                      delete dataNew[endTime];
                      var storeData = {
                        dataNew: _objectSpread({}, dataNew),
                        todayHoure: currentHourList,
                        houreDate: endTime
                      };

                      _this.$DBControls.update(_this.name + _this.dataConvert(), storeData);

                      _this.IntegralrawData = dataToUpdate;

                      _this.IntegralscreenControls();
                    }
                  };

                  if (!dbres) {
                    _context.next = 38;
                    break;
                  }

                  PrimitiveList = _this.$times.getDayAll(startTime, endTime);
                  dateList = JSON.parse(JSON.stringify(PrimitiveList)).reverse();
                  cacheHourData = dbres.content.houreDate == endTime ? dbres.content.todayHoure : {};
                  cacheHourObj = Object.keys(cacheHourData).map(function (i) {
                    return parseInt(i);
                  });
                  list = {};
                  day = 3;
                  numt = 3;
                  dateList.forEach(function (i) {
                    if (dbres.content.dataNew[i]) {
                      list[i] = dbres.content.dataNew[i];
                      numt--;
                    }
                  });

                  if (numt == 2) {
                    day = 2;
                  } else if (numt == 1) {
                    day = 1;
                  }

                  hourDate = {};

                  if (numt == 1) {
                    mathNum = Math.max.apply(null, cacheHourObj) + 1;
                    hourDate = {
                      start_hour: cacheHourObj.length ? mathNum < 10 ? "0".concat(mathNum) : mathNum : '00',
                      end_hour: currentHour
                    };
                  }

                  _context.next = 32;
                  return reqFn(_objectSpread(_objectSpread(_objectSpread({
                    days: day,
                    time: numt == 3 ? startTime : dateList[day - 1],
                    kind: 1
                  }, _this.searchData), _this.defaultData()), hourDate));

                case 32:
                  queryData = _context.sent;

                  if (numt == 1) {
                    queryData.data[endTime] = _objectSpread(_objectSpread({}, cacheHourData), queryData.data.data[endTime]); // 默认数据

                    defaultData = {
                      "activate_device": 0,
                      "new_device_recharge_amount": 0,
                      "new_device_recharge_num": 0,
                      "recharge_amount": 0,
                      "register_num": 0,
                      "login_num": 0,
                      "recharge_num": 0,
                      "online_num": 0,
                      "arppu": 0,
                      "register_recharge_pnum": 0,
                      "register_recharge_amount": 0,
                      "recharge_amountexchange": 0,
                      "register_recharge_amountexchange": 0,
                      "new_device_recharge_amountexchange": 0,
                      "date": endTime
                    };

                    _this.hourList.forEach(function (i) {
                      if (!queryData.data[endTime][i < 10 ? "0".concat(i) : i]) {
                        queryData.data[endTime][i < 10 ? "0".concat(i) : i] = _objectSpread({}, defaultData);
                      }
                    });
                  }

                  queryData.data = _objectSpread(_objectSpread({}, list), queryData.data);
                  handleQueryData(queryData);
                  _context.next = 60;
                  break;

                case 38:
                  recombination = {
                    status: 200,
                    data: {}
                  };
                  searchHoour = [];
                  querylist = [];

                  _this.hourList.forEach(function (i) {
                    var h = i < 10 ? "0".concat(i) : i;
                    searchHoour.push(h);
                  });

                  i = 0;

                case 43:
                  if (!(i < searchHoour.length)) {
                    _context.next = 59;
                    break;
                  }

                  Hds = {
                    start_hour: searchHoour[i],
                    end_hour: searchHoour[i]
                  };
                  _context.next = 47;
                  return reqFn(_objectSpread(_objectSpread(_objectSpread({
                    days: 3,
                    time: startTime,
                    kind: 1
                  }, _this.searchData), _this.defaultData()), Hds));

                case 47:
                  qd = _context.sent;

                  if (!(qd.status == 200 || qd.code == 200)) {
                    _context.next = 54;
                    break;
                  }

                  // querylist.push({ ...qd.data })
                  for (k in qd.data.data) {
                    hd = _objectSpread(_objectSpread({}, recombination.data[k]), qd.data.data[k]);
                    recombination.data[k] = hd;
                  }

                  _this.IntegralrawData = _objectSpread({}, recombination.data);

                  _this.IntegralscreenControls();

                  _context.next = 56;
                  break;

                case 54:
                  _this.reqLoading = false;
                  return _context.abrupt("break", 59);

                case 56:
                  i++;
                  _context.next = 43;
                  break;

                case 59:
                  // querylist.forEach(i => {
                  //   for (let k in i.data) {
                  //     let hd = { ...recombination.data[k], ...i.data[k] }
                  //     recombination.data[k] = hd
                  //   }
                  // })
                  // const queryData = await reqFn({ days: 3, time: startTime, kind: 1, ...this.searchData, ...this.defaultData() });
                  handleQueryData(recombination);

                case 60:
                  _this.reqLoading = false;

                case 61:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    IntegralscreenControls: function IntegralscreenControls() {
      var _this2 = this;

      var tableData = [];
      var tableList = [];
      var knum = -1;
      var screen = [];
      this.originaltableList.map(function (item) {
        if (_this2.screen.findIndex(function (t) {
          return t == item.key;
        }) > -1) {
          screen.push(item);
        }
      });
      screen.forEach(function (item) {
        tableList.push({
          label: item.name,
          prop: item.key,
          list: []
        });
      });
      var listLength = 0;

      var _loop = function _loop(i) {
        if (!listLength) {
          listLength = Object.keys(_this2.IntegralrawData[i]).length;
        } // 表格头部数据处理


        var d = {};

        for (var k in _this2.IntegralrawData[i]) {
          var c = k.substring(0, 1) == "0" ? k.substring(1, 2) : k;
          d[c] = _this2.IntegralrawData[i][k];
          d[c]['date'] = i;
        }

        tableList.map(function (item) {
          item.list.push({
            label: i,
            prop: item.prop + i
          });
        }); // 表格数据处理

        for (var _k in d) {
          knum += 1;
          var h = parseInt(_k) + 1;
          tableData.push({
            hours: (_k < 10 ? '0' + _k : _k) + '~' + (h < 10 ? '0' + h : h) + '点'
          });
          d[_k]['recharge_amountexchange'] = Number(d[_k]['recharge_amount']) * _this2.exchangeRate;
          d[_k]['register_recharge_amountexchange'] = Number(d[_k]['register_recharge_amount']) * _this2.exchangeRate;
          d[_k]['new_device_recharge_amountexchange'] = Number(d[_k]['new_device_recharge_amount']) * _this2.exchangeRate;

          for (var j in d[_k]) {
            var text = d[_k][j];

            if (j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'arppu' || j == 'new_device_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
              if (j == 'new_device_recharge_amount' || j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
                text = _this2.isyjfmvnd() ? Number(d[_k][j]).toFixed(3) : _this2.$utils.conversion(d[_k][j]).toFixed(2);
              } else {
                text = _this2.$utils.conversion(d[_k][j]).toFixed(2);
              }
            }

            tableData[knum][j + d[_k]['date']] = text;
          }

          if (knum == listLength - 1) {
            knum = -1;
          }
        }
      };

      for (var i in this.IntegralrawData) {
        _loop(i);
      }

      tableData.splice(listLength, tableData.length - listLength);
      tableList.unshift({
        label: '',
        list: [{
          label: '时间',
          prop: 'hours',
          width: 100
        }]
      });
      this.tableData = tableData;
      this.tableList = tableList;
    }
  }
};